import { EBureauType, getScoreDetailsByBureau } from '@modules/ContactManager/components/Header/interfaces';
import { IOption } from '@shared/interfaces';

export const transunionBureauList = getScoreDetailsByBureau(EBureauType.Transunion).map((scoreDetail) => ({
  value: scoreDetail.mappedValue,
  label: scoreDetail.label,
}));

export const bureausList = getScoreDetailsByBureau().map((scoreDetail) => ({
  value: scoreDetail.mappedValue,
  label: scoreDetail.label,
}));

export const productTypes: IOption[] = [
  {
    value: 'Gap',
    label: 'Gap',
  },
  {
    value: 'Vsc',
    label: 'Vsc',
  },
  {
    value: 'Com',
    label: 'Com',
  },
  {
    value: 'Paf',
    label: 'Paf',
  },
  {
    value: 'Vrp',
    label: 'Vrp',
  },
  {
    value: 'Mbi',
    label: 'Mbi',
  },
  {
    value: 'Mba',
    label: 'Mba',
  },
];
